import { useState, useCallback } from "react";

export const useMeetingUI = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isControlPanelOpen, setIsControlPanelOpen] = useState(false);
  const [showJoinDialog, setShowJoinDialog] = useState(false);
  const [isLinkMeetingOpen, setIsLinkMeetingOpen] = useState(false);

  const handleToggleChat = useCallback(() => {
    setIsChatOpen((prev) => !prev);
  }, []);

  const handleToggleControlPanel = useCallback(() => {
    setIsControlPanelOpen((prev) => !prev);
  }, []);

  const handleCloseChat = useCallback(() => {
    setIsChatOpen(false);
  }, []);

  const handleCloseControlPanel = useCallback(() => {
    setIsControlPanelOpen(false);
  }, []);

  return {
    isChatOpen,
    isControlPanelOpen,
    showJoinDialog,
    isLinkMeetingOpen,
    setIsChatOpen,
    setIsControlPanelOpen,
    setShowJoinDialog,
    setIsLinkMeetingOpen,
    handleToggleChat,
    handleToggleControlPanel,
    handleCloseChat,
    handleCloseControlPanel,
  };
};

